// import Swiper JS
import Swiper from 'swiper/bundle';
import SwiperCore, { Navigation, Pagination } from 'swiper/core';

export function sliders()
{
	SwiperCore.use([Navigation, Pagination]);

	/**
	 * Hash listner for testimonial slider
	 */
	const testimonialBtns = document.querySelectorAll('.testimonial-hash-btn');

	const addClass = (element, classname) => {
		testimonialBtns.forEach((btn, index) => {
			btn.classList.remove(classname);
		})

		element.classList.add(classname);
	}

	testimonialBtns.forEach((btn, index) => {
		btn.addEventListener('click', (e) => {
			let target = e.currentTarget;
			addClass(target, 'active');
		})
	})

	/**
	 * Change the options here - you can use data-* tags to specify 
	 * different values for different sliders
	 */
	let sliders = document.querySelectorAll('.slider');

	sliders.forEach((slider, index) => {
		let parent = slider.parentNode;

		/**
		 * Home Story slider settings
		 */
		// let slidesPerView = 1;
		// let loop = true;
		let margin = slider.getAttribute('data-margin')
			? parseInt(slider.getAttribute('data-margin'))
			: 20;

		let useNav = slider.getAttribute('data-nav')
			&& slider.getAttribute('data-nav') == 'true'
			? {
					nextEl: parent.querySelector('.slider-arrow.next'),
					prevEl: parent.querySelector('.slider-arrow.prev'),
				}
			: false;
		
		let slideDirection = slider.getAttribute('data-direction')
			? slider.getAttribute('data-direction')
			: 'horizontal';

		if (parent.classList.contains('your-slider'))
		{
			useNav = {
				nextEl: document.querySelector('.yourslider-pagination__btn.next'),
				prevEl: document.querySelector('.yourslider-pagination__btn.prev'),
			};
		}

		let autoplay = slider.getAttribute('data-autoplay')
			&& slider.getAttribute('data-autoplay') === 'false'
			? false
			: true;

		let useLoop = slider.getAttribute('data-loop')
			&& slider.getAttribute('data-loop') === 'false'
			? false
			: true;
	
		let slidesPerView = slider.getAttribute('data-slides')
			? slider.getAttribute('data-slides')
			: 1;

		let useHash = slider.getAttribute('data-hash')
			&& slider.getAttribute('data-hash') == 'true'
			? {
					watchState: true,
				}
			: false;
		
		let usePagination = slider.getAttribute('data-pagination')
			&& slider.getAttribute('data-pagination') == 'true'
			? {
					el: parent.querySelector('.slider-pagination'),
					clickable: true,
					type: 'bullets',
					renderBullet: (index, className) =>
						`<div class="slider-bullet ${className}" data-id="${index}">
							<div class="slider-bullet__inner"></div>
							<svg viewBox="0 0 20 21">
								<use xlink:href="#bullet" />
							</svg>
						</div>`,
				}
			: false;

		const swiper = new Swiper(slider, {
			slidesPerView: slidesPerView,
			spaceBetween: 20,
			speed: 400,
			loop: useLoop,
			autoplay: autoplay,
			navigation: useNav,
			pagination: usePagination,
			direction: slideDirection,
			createElements: true,
			observer: true,
			observeParents: true,
			observeSlideChildren: true,
			hashNavigation: useHash,
			breakpoints: {
				900: {
					spaceBetween: margin,
				},
			},
			on: {
				activeIndexChange: (swiper) => {
					const { realIndex } = swiper || {}

					if (slider.classList.contains('testimonal-slider'))
					{
						parent.querySelectorAll('.testimonial-hash-btn')
							.forEach((node, index) => {
								(index === realIndex)
									? node.classList.add('active')
									: node.classList.remove('active')
							})
					}

					if (slider.classList.contains('quote-slider'))
					{
						parent.parentNode
							.querySelectorAll('.quote-block__image-inner')
							.forEach((node, index) => {
								(index !== realIndex)
									? node.classList.add('active')
									: node.classList.remove('active')
							})
					}
				},
			},
		})

		// This uses synthetic clicks to trigger animtions
		if (parent.classList.contains('scroller-gallery')) {
			let trigger = parent.querySelector('.scroller-gallery__trigger');

			trigger.addEventListener('click', (e) => {
				let activeSlide = e.currentTarget.getAttribute('data-slide');

				let index = parseInt(activeSlide) - 1 > 0
					? parseInt(activeSlide) - 1
					: 0;
				
				swiper.slideTo(index, 600)
			})
		}

		if (useNav)
		{
			swiper.navigation.init();
			swiper.navigation.update();
		}

		if (usePagination)
		{
			swiper.pagination.init();
			swiper.pagination.update();
		}
	});
}



// WEBPACK FOOTER //
// ./scripts/modules/sliders.js